<template>
    <section class="padding-vertical-content lightgray-content">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-uppercase text-center">
                        <template v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                            {{ texto_producto_extra }}
                        </template>
                        <template v-else>
                            <h4 class="text-uppercase text-center">🅿️ Haz que tu experiencia en el estadio sea completa</h4>
                            <p>¿Ya tienes tu abono? ¡Perfecto! Ahora añade tu abono de parking y olvídate del estrés antes del partido.</p>
                            <p>Con el abono de parking disfrutarás de:</p>
                            <ul>
                                <li><b>Plaza garantizada</b> en cada jornada en zona reservada.</li>
                                <li><b>Acceso rápido y cómodo</b>, sin dar vueltas buscando sitio</li>
                                <li>Entrada preferente para llegar sin prisas y salir con tranquilidad</li>
                                <li>Ideal si vienes en familia, con amigos o desde fuera de la ciudad</li>
                            </ul>
                            <p>No te arriesgues a llegar tarde, perder tiempo ni aparcar lejos.</p>
                            <p><b>Asegura tu sitio y vive el Real Murcia C.F.  desde el minuto cero.</b></p>
                            <p>👉 Marca esta opción en tu compra y <b>activa tu abono de parking</b> para toda la temporada.</p>
                        </template>
                    </h4>
                    <div class="col-12 d-flex align-center">
                        <Button
                            :label="$t('eventos.si_anadir')"
                            custom-class="ml-1 mr-1 col-6"
                            @click="continuarProductoExtra(true)"
                        />
                        <Button
                            :label="$t('eventos.no_continuar')"
                            custom-class="mr-2 col-6"
                            @click="continuarProductoExtra(false)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';
    import Button from '@/modules/ui/Button.vue';

    const teatro = computed(() => store.getters.getTeatro);

    const props = defineProps({
        texto_producto_extra: {
            type: String,
            required: true
        }
    });

    const emit = defineEmits(['continuarProductoExtra']);

    const continuarProductoExtra = add => {
        emit('continuarProductoExtra', add);
    };
</script>
